<template lang="pug">
  .container-main.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/merchants-information") 商户资料
          el-breadcrumb-item 修改资料
    cBox.display-flex(v-loading="loading", :element-loading-fullscreen="false")
      el-steps.width-680(:active="step" finish-status="success" :align-center="true")
        el-step(title="商户基本资料修改")
          template(slot="description")
            h3(v-if="step1Change").txt-tip-warn （有变更）
            h3(v-else) （无变更）
        el-step(title="钱包提现账号修改",v-if='source.type == 1')
          template(slot="description")
            h3(v-if="step2Change").txt-tip-warn （有变更）
            h3(v-else) （无变更）
        el-step(title="修改信息确认")
      template(v-if="step === 0")
        .txt-tip-warn.font-size-20 注意：商户基本资料修改，将对商户所有钱包进行统一的资料变更，请谨慎修改
        el-form(:model="source", label-position="right", label-width="200px")
          template(v-if="source.type == 1")
            hr
            h4 基本信息
            el-row(:gutter="10")
              el-col(:span="12")
                el-form-item(label="商户类型") {{ source.type | type }}
                el-form-item(label="公司名称", required)
                  el-input(v-model.trim="source.mch_name")
                template(v-if="source.opt == 1") 
                  el-form-item(label="统一社会信用代码或注册号", required)
                    el-input(v-model.trim="source.uni_credit")
                template(v-else)
                  el-form-item(label="营业执照号", required)
                    el-input(v-model.trim="source.business_license")
                  el-form-item(label="组织机构代码", required)
                    el-input(v-model.trim="source.organization_code")
                  el-form-item(label="税务登记证件号", required)
                    el-input(v-model.trim="source.tax_registration_no")
              el-col(:span="12")
                el-form-item(label="") &nbsp;
                el-form-item(label="营业执照类型", required)
                  el-select(v-model.trim="source.opt")
                    el-option(:value="1", label="三证合一，一证一码")
                    el-option(:value="2", label="一证三号或三证独立")
                el-form-item(label="营业执照照片", required)
                  el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                    :show-file-list="false", :on-change="(file) => uploadChange(file, 'business_license_pic_preview', 'business_license_pic')")
                    el-button(type="primary") 选择文件
                el-form-item(label="")
                  img(v-if="source.business_license_pic", :src="source.business_license_pic | image", 
                    @click="$zoom($options.filters.image(source.business_license_pic))").mch-image
                  img(v-else-if="source.business_license_pic_preview", :src="source.business_license_pic_preview",
                    @click="$zoom(source.business_license_pic_preview)").mch-image
                  template(v-else) 未上传
            hr
            h4 法人信息
            el-row(:gutter="10")
              el-col(:span="12")
                el-form-item(label="法人姓名", required)
                  el-input(v-model.trim="source.legal_per_name")
                el-form-item(label="法人证件号码", required)
                  el-input(v-model.trim="source.legal_per_id_no")
                el-form-item(label="法人手机号", required)
                  el-input(v-model.trim="source.legal_per_telephone_no")
              el-col(:span="12")
                el-form-item(label="法人证件类型",required)
                  el-select(v-model.trim="source.legal_per_id_type")
                    el-option(value="01", label="身份证")
                el-form-item(label="身份证照片",required)
                  el-row
                    el-col(:span="12")
                      el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                        :show-file-list="false", :on-change="(file) => uploadChange(file, 'legal_per_id_positive_preview', 'legal_per_id_positive')")
                        el-button(type="primary") 姓名面
                    el-col(:span="12")
                      el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                        :show-file-list="false", :on-change="(file) => uploadChange(file, 'legal_per_id_opposite_preview', 'legal_per_id_opposite')")
                        el-button(type="primary") 国徽面
                el-form-item(label="")
                  el-row
                    el-col(:span="12")
                      img(v-if="source.legal_per_id_positive", :src="source.legal_per_id_positive | image", 
                        @click="$zoom($options.filters.image(source.legal_per_id_positive))").mch-image
                      img(v-else-if="source.legal_per_id_positive_preview", :src="source.legal_per_id_positive_preview",
                        @click="$zoom(source.legal_per_id_positive_preview)").mch-image
                      template(v-else) 未上传
                    el-col(:span="12")
                      img(v-if="source.legal_per_id_opposite", :src="source.legal_per_id_opposite | image", 
                        @click="$zoom($options.filters.image(source.legal_per_id_opposite))").mch-image
                      img(v-else-if="source.legal_per_id_opposite_preview", :src="source.legal_per_id_opposite_preview",
                        @click="$zoom(source.legal_per_id_opposite_preview)").mch-image
                      template(v-else) 未上传
            hr
            h4 责任人信息
            el-row(:gutter="10")
              el-col(:span="12")
                el-form-item(label="责任人姓名", required)
                  el-input(v-model.trim="source.resp_per_name")
                el-form-item(label="责任人证件号码", required)
                  el-input(v-model.trim="source.resp_per_id_no")
              el-col(:span="12")
                el-form-item(label="责任人证件类型", required)
                  el-select(v-model.trim="source.resp_per_id_type")
                    el-option(value="01", label="身份证")
          template(v-else)
            h4 基本信息
            el-row(:gutter="10")
              el-col(:span="12")
                el-form-item(label="商户类型") 个人
                el-form-item(label="姓名", required)
                  el-input(v-model.trim="source.resp_per_name")
                el-form-item(label="证件号", required)
                  el-input(v-model.trim="source.resp_per_id_no", :disabled="source.origin_mch.status !== 3 ") 
              el-col(:span="12")
                el-form-item(label="") &nbsp;
                el-form-item(label="证件类型", required)
                  el-select(v-model.trim="source.resp_per_id_type")
                    el-option(value="01", label="身份证")
            h4 补充资料
            el-row(:gutter="10")     
              el-col(:span="12")
                el-form-item(label="营业执照")
                  el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                    :show-file-list="false", :on-change="(file) => uploadChange(file, 'business_license_pic_preview', 'business_license_pic')")
                    el-button(type="primary") 选择文件
                el-form-item(label="")
                  img(v-if="source.business_license_pic", :src="source.business_license_pic | image", 
                    @click="$zoom($options.filters.image(source.business_license_pic))").mch-image
                  img(v-else-if="source.business_license_pic_preview", :src="source.business_license_pic_preview",
                    @click="$zoom(source.business_license_pic_preview)").mch-image
                  template(v-else) 未提交
              el-col(:span="12")
                el-form-item(label="身份证件照片")
                  el-row
                    el-col(:span="12")
                      el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                      :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_positive_preview', 'resp_per_id_positive')")
                        el-button(type="primary") 上传身份证正面
                      img(v-if="source.resp_per_id_positive", :src="source.resp_per_id_positive | image",
                        @click="$zoom($options.filters.image(source.resp_per_id_positive))").mch-image
                      img(v-else-if="source.resp_per_id_positive_preview", :src="source.resp_per_id_positive_preview",
                        @click="$zoom(source.resp_per_id_positive_preview)").mch-image
                      template(v-else) 未提交
                    el-col(:span="12")
                      el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*", :show-file-list="false", :on-change="(file) => uploadChange(file, 'resp_per_id_opposite_preview', 'resp_per_id_opposite')")
                        el-button(type="primary") 上传身份证反面
                      img(v-if="source.resp_per_id_opposite", :src="source.resp_per_id_opposite | image",
                        @click="$zoom($options.filters.image(source.resp_per_id_opposite))").mch-image
                      img(v-else-if="source.resp_per_id_opposite_preview", :src="source.resp_per_id_opposite_preview",
                        @click="$zoom(source.resp_per_id_opposite_preview)").mch-image
                      template(v-else) 未提交
          hr
          .align-center.txt-tip-warn 请根据签约的业务及合同要求，完善商家资料信息，否则将审核不通过。
          br
      template(v-if="step === 1")
        h4 钱包提现账号
        el-form(label-position="right", label-width="200px")
          el-row(:gutter="10",v-for='(item,idx) in mch_public_draft_list',:key="idx")
            .wallet-info
              template(v-if="item.isEdit")
                el-col(:span="12")
                  el-form-item(label="钱包名",required)
                    el-input(v-model.trim="editPublicObj.public_account_name",disabled)
                  el-form-item(label="开户名",required)
                    el-input(v-model.trim="editPublicObj.public_account_name",disabled)
                  el-form-item(label="开户银行",required)
                    el-select(v-model="editPublicObj.bankClass", clearable, @change="getBankAreaList()", filterable,value-key="class_code")
                      el-option(v-for="b in bankClassList", :key="b.class_code", :value="b", :label="b.class_name")
                  el-form-item(label="开户银行所在地",required)
                    el-select(v-model.trim="editPublicObj.bankArea", @change="getBankList()", clearable, filterable,value-key="area_code")
                      el-option(v-for="b in bankAreaList", :key="b.area_code", :value="b", :label="b.province_name + b.city_name")
                  el-form-item(label="支行名称",required)
                    el-select(v-model.trim="editPublicObj.bank", clearable, filterable, value-key="bank_code", @change="getBank()" )
                      el-option(v-for="b in bankList", :key="b.bank_code", :value="b", :label="b.bank_name")
                  el-form-item(label="对公账户账号",required)
                    el-input(v-model.trim="editPublicObj.public_account")
                el-col(:span="12")
                  el-form-item(label="对公账户证明",required)
                    el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                      :show-file-list="false", :on-change="(file) => uploadPublicChange(file, 'public_account_pic_preview', 'public_account_pic')")
                      el-button(type="primary") 选择文件
                  el-form-item(label="")
                      img(v-if="editPublicObj.public_account_pic", :src="editPublicObj.public_account_pic | image", 
                      @click="$zoom($options.filters.image(editPublicObj.public_account_pic))").mch-image
                      img(v-else-if="editPublicObj.public_account_pic_preview", :src="editPublicObj.public_account_pic_preview",
                      @click="$zoom(editPublicObj.public_account_pic_preview)").mch-image
                      template(v-else) 未上传
                el-col(:span="24")
                    .editPublic
                      el-button(type="primary",@click="confirmPublic(idx)") 保存上述提现账号
                      el-button(type="primary",@click="cancelPublic(idx)") 放弃修改
              template(v-else)
                el-col(:span="12")
                  el-form-item(label="钱包名") {{ item.public_account_name || '未填写' }}
                  el-form-item(label="开户名") {{ item.public_account_name || '未填写' }}
                  el-form-item(label="开户银行") {{ item.deposit_bank || '未填写' }}
                  el-form-item(label="开户银行所在地") {{ item.deposit_bank_city ? `${item.deposit_bank_province}${item.deposit_bank_city}`:'未填写' }}
                  el-form-item(label="支行名称") {{ item.sub_branch_bank || '未填写' }}
                  el-form-item(label="对公账户账号") {{ item.public_account || '未填写' }}
                el-col(:span="12")
                  el-form-item(label="对公账户证明")
                      img(v-if="item.public_account_pic", :src="item.public_account_pic | image",
                          @click="$zoom($options.filters.image(item.public_account_pic))").mch-image
                      template(v-else) 未提交
                el-col(:span="24")
                    .editPublic
                      el-button(type="primary",@click="editPublic(idx)") 修改上述提现账号
                el-col(:span="24",v-if="item.submitMsg")
                    .tipTxt {{item.submitMsg}}
      template(v-if="step === 2")
        template(v-if="source.type === 1")
          .confirm-content
            .confirm-row
              .col-name
              .col-new-info.font-size-20 变更资料
              .col-old-info.font-size-20 当前资料
            h4 基本信息
            .confirm-row    
              .col-name 商户主体类型
              .col-new-info 公司
              .col-old-info 公司
            .confirm-row    
              .col-name 公司名称
              .col-new-info
                .txt-diff(v-if='source.mch_name !== basicSource.mch_name') {{source.mch_name || '未填写'}}
                span(v-else) {{source.mch_name || '未填写'}}
              .col-old-info {{basicSource.mch_name || '未填写'}}
            .confirm-row   
              .col-name 营业执照类型
              .col-new-info
                .txt-diff(v-if='source.opt !== basicSource.opt') {{source.opt === 1 ? '三证合一，一证一码' : '一证三码，三码独立'}}
                span(v-else) {{source.opt === 1 ? '三证合一，一证一码' : '一证三码，三码独立'}}
              .col-old-info {{basicSource.opt === 1 ? '三证合一，一证一码' : '一证三码，三码独立'}}
            .confirm-row(v-if='source.opt === 1')    
              .col-name 注册号/统一社会信用代码
              .col-new-info
                .txt-diff(v-if='source.uni_credit !== basicSource.uni_credit') {{source.uni_credit || '未填写'}}
                span(v-else) {{source.uni_credit || '未填写'}}
              .col-old-info {{basicSource.uni_credit || '未填写'}}
            .confirm-row(v-if='source.opt === 2')    
              .col-name 营业执照号
              .col-new-info
                .txt-diff(v-if='source.business_license !== basicSource.business_license') {{source.business_license || '未填写'}}
                span(v-else) {{source.business_license || '未填写'}}
              .col-old-info {{basicSource.business_license || '未填写'}}
            .confirm-row(v-if='source.opt === 2')    
              .col-name 组织机构代码
              .col-new-info
                .txt-diff(v-if='source.organization_code !== basicSource.organization_code') {{source.organization_code || '未填写'}}
                span(v-else) {{source.organization_code || '未填写'}}
              .col-old-info {{basicSource.organization_code || '未填写'}}
            .confirm-row(v-if='source.opt === 2')    
              .col-name 税务登记证件号
              .col-new-info
                .txt-diff(v-if='source.tax_registration_no !== basicSource.tax_registration_no') {{source.tax_registration_no || '未填写'}}
                span(v-else) {{source.tax_registration_no || '未填写'}}
              .col-old-info {{basicSource.tax_registration_no || '未填写'}}
            .confirm-row    
              .col-name 营业执照图片
              .col-new-info
                img(v-if="source.business_license_pic", :src="source.business_license_pic | image",
                    @click="$zoom($options.filters.image(source.business_license_pic))", :style="{border:(source.business_license_pic!==basicSource.business_license_pic?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info
                img(v-if="basicSource.business_license_pic", :src="basicSource.business_license_pic | image",
                    @click="$zoom($options.filters.image(basicSource.business_license_pic))").mch-image
                template(v-else) 未提交
            hr
            h4 法人信息
            .confirm-row    
              .col-name 法人姓名
              .col-new-info
                .txt-diff(v-if='source.legal_per_name !== basicSource.legal_per_name') {{source.legal_per_name || '未填写'}}
                span(v-else) {{source.legal_per_name || '未填写'}}
              .col-old-info {{basicSource.legal_per_name || '未填写'}}
            .confirm-row    
              .col-name 法人手机
              .col-new-info
                .txt-diff(v-if='source.legal_per_telephone_no !== basicSource.legal_per_telephone_no') {{source.legal_per_telephone_no || '未填写'}}
                span(v-else) {{source.legal_per_telephone_no || '未填写'}}
              .col-old-info {{basicSource.legal_per_telephone_no || '未填写'}}
            .confirm-row    
              .col-name 证件类型
              .col-new-info
                .txt-diff(v-if='source.legal_per_id_type !== basicSource.legal_per_id_type') {{source.legal_per_id_type | resp_per_id_type}}
                span(v-else) {{source.legal_per_id_type | resp_per_id_type}}
              .col-old-info {{basicSource.legal_per_id_type | resp_per_id_type}}
            .confirm-row    
              .col-name 证件号码
              .col-new-info
                .txt-diff(v-if='source.legal_per_id_no !== basicSource.legal_per_id_no') {{source.legal_per_id_no || '未填写'}}
                span(v-else) {{source.legal_per_id_no || '未填写'}}
              .col-old-info {{basicSource.legal_per_id_no || '未填写'}}
            //- .confirm-row    
            //-   .col-name 证件有效期
            //-   .col-new-info
            //-     .txt-diff(v-if='source.mch_name !== basicSource.mch_name') {{source.mch_name || '未填写'}}
            //-     span(v-else) {{source.mch_name || '未填写'}}
            //-   .col-old-info {{basicSource.mch_name || '未填写'}}
            .confirm-row    
              .col-name 身份证(人像面)
              .col-new-info
                img(v-if="source.legal_per_id_positive", :src="source.legal_per_id_positive | image",
                    @click="$zoom($options.filters.image(source.legal_per_id_positive))", :style="{border:(source.legal_per_id_positive!==basicSource.legal_per_id_positive?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info
                img(v-if="basicSource.legal_per_id_positive", :src="basicSource.legal_per_id_positive | image",
                    @click="$zoom($options.filters.image(basicSource.legal_per_id_positive))").mch-image
                template(v-else) 未提交
            .confirm-row    
              .col-name 身份证(国徽面)
              .col-new-info
                img(v-if="source.legal_per_id_opposite", :src="source.legal_per_id_opposite | image",
                    @click="$zoom($options.filters.image(source.legal_per_id_opposite))", :style="{border:(source.legal_per_id_opposite!==basicSource.legal_per_id_opposite?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info
                img(v-if="basicSource.legal_per_id_opposite", :src="basicSource.legal_per_id_opposite | image",
                    @click="$zoom($options.filters.image(basicSource.legal_per_id_opposite))").mch-image
                template(v-else) 未提交
            hr
            h4 责任人信息
            .confirm-row    
              .col-name 责任人姓名
              .col-new-info
                .txt-diff(v-if='source.resp_per_name !== basicSource.resp_per_name') {{source.resp_per_name || '未填写'}}
                span(v-else) {{source.resp_per_name || '未填写'}}
              .col-old-info {{basicSource.resp_per_name || '未填写'}}
            .confirm-row    
              .col-name 责任人证件类型
              .col-new-info
                .txt-diff(v-if='source.resp_per_id_type !== basicSource.resp_per_id_type') {{source.resp_per_id_type | resp_per_id_type}}
                span(v-else) {{source.resp_per_id_type | resp_per_id_type}}
              .col-old-info {{basicSource.resp_per_id_type | resp_per_id_type}}
            .confirm-row    
              .col-name 责任人证件号码
              .col-new-info
                .txt-diff(v-if='source.resp_per_id_no !== basicSource.resp_per_id_no') {{source.resp_per_id_no || '未填写'}}
                span(v-else) {{source.resp_per_id_no || '未填写'}}
              .col-old-info {{basicSource.resp_per_id_no || '未填写'}}              

            hr
            h4 钱包提现账号信息
            .confirm-wallet(v-for='(item,idx) in confirm_mch_public_draft_list',:key="idx")
              .confirm-row    
                .col-name 开户名
                .col-new-info
                  .txt-diff(v-if='item.public_account_name !== item.source.public_account_name') {{item.public_account_name || '未填写'}}
                  span(v-else) {{item.public_account_name || '未填写'}}
                .col-old-info {{item.source.public_account_name || '未填写'}}
              .confirm-row    
                .col-name 开户银行
                .col-new-info
                  .txt-diff(v-if='item.deposit_bank !== item.source.deposit_bank') {{`${item.deposit_bank}` || '未填写'}}
                  span(v-else) {{`${item.deposit_bank}` || '未填写'}}
                .col-old-info {{`${item.source.deposit_bank}` || '未填写'}}
              .confirm-row    
                .col-name 开户银行所在地
                .col-new-info
                  .txt-diff(v-if='item.deposit_bank_city !== item.source.deposit_bank_city') {{`${item.deposit_bank_province}${item.deposit_bank_city}` || '未填写'}}
                  span(v-else) {{`${item.deposit_bank_province}${item.deposit_bank_city}` || '未填写'}}
                .col-old-info  {{`${item.source.deposit_bank_province}${item.source.deposit_bank_city}` || '未填写'}}
              .confirm-row    
                .col-name 支行名称
                .col-new-info
                  .txt-diff(v-if='item.sub_branch_bank !== item.source.sub_branch_bank') {{item.sub_branch_bank || '未填写'}}
                  span(v-else) {{item.sub_branch_bank || '未填写'}}
                .col-old-info {{item.source.sub_branch_bank || '未填写'}}
              .confirm-row    
                .col-name 对公账户账号
                .col-new-info
                  .txt-diff(v-if='item.public_account !== item.source.public_account') {{item.public_account || '未填写'}}
                  span(v-else) {{item.public_account || '未填写'}}
                .col-old-info {{item.source.public_account || '未填写'}}
              .confirm-row    
                .col-name 对公账户证明
                .col-new-info
                  img(v-if="item.public_account_pic", :src="item.public_account_pic | image",
                      @click="$zoom($options.filters.image(item.public_account_pic))", :style="{border:(item.public_account_pic!==item.source.public_account_pic?'1px solid red':'none')}").mch-image
                  template(v-else) 未提交
                .col-old-info
                  img(v-if="item.source.public_account_pic", :src="item.source.public_account_pic | image",
                      @click="$zoom($options.filters.image(item.source.public_account_pic))").mch-image
                  template(v-else) 未提交
            h4 资料修改申请
              .confirm-row   
                el-row(:gutter="20",v-if="source.origin_mch.enable_wallet_settle===1 && source.origin_mch.status===2")
                  el-col(:span="24")
                    div 为符合支付机构对商户资料安全的监管要求，修改除责任人姓名、责任人证件号码以外的其他信息时，需下载填写申请函模板内容，并打印、加盖公司公章，上传复印件，并将原件交给平台商务负责人。
                  el-col(:span="24")
                    el-form(ref="form" :model="form" label-width="240px")
                      el-form-item(label="资料修改申请函",required)
                        a(href="./down/资料修改申请函.docx" download="资料修改申请函.docx") 点击下载
                      el-form-item(label="申请函",required)
                        div 请上传1-9张JPG或PNG格式的图片
                        el-upload(ref="upload", :action="uploadURL", :auto-upload="false", accept="image/*",
                          :show-file-list="false", :on-change="(file) => uploadListChange(file)")
                          el-button(type="primary") 选择文件
                        el-form-item(label="")
                          .img-block(v-for="(item,$index) in change_apply_pic")
                            img(v-if="item", :src="item | image", @click="$zoom($options.filters.image(item))").mch-image.mr-20
                            .del-img(@click="delImg($index)") 删除
                          template(v-if="change_apply_pic.length===0") 未上传
        template(v-else)
          .confirm-content
            .confirm-row
              .col-name
              .col-new-info.font-size-20.bold 变更资料
              .col-old-info.font-size-20.bold 当前资料
            h4 基本信息
            .confirm-row
              .col-name 商户主体类型
              .col-new-info 个人
              .col-old-info 个人
            .confirm-row    
              .col-name 姓名
              .col-new-info
                .txt-diff(v-if='source.resp_per_name !== basicSource.resp_per_name') {{source.resp_per_name || '未填写'}}
                span(v-else) {{source.resp_per_name || '未填写'}}
              .col-old-info {{basicSource.resp_per_name || '未填写'}}
            .confirm-row    
              .col-name 证件号码
              .col-new-info
                .txt-diff(v-if='source.resp_per_id_no !== basicSource.resp_per_id_no') {{source.resp_per_id_no || '未填写'}}
                span(v-else) {{source.resp_per_id_no || '未填写'}}
              .col-old-info {{basicSource.resp_per_id_no || '未填写'}}
            .confirm-row    
              .col-name 营业执照
              .col-new-info
                img(v-if="source.business_license_pic", :src="source.business_license_pic | image",
                    @click="$zoom($options.filters.image(source.business_license_pic))", :style="{border:(source.business_license_pic!==basicSource.business_license_pic?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info
                img(v-if="basicSource.business_license_pic", :src="basicSource.business_license_pic | image",
                    @click="$zoom($options.filters.image(basicSource.business_license_pic))").mch-image
                template(v-else) 未提交
            .confirm-row    
              .col-name 身份证(人像面)
              .col-new-info
                img(v-if="source.resp_per_id_positive", :src="source.resp_per_id_positive | image",
                    @click="$zoom($options.filters.image(source.resp_per_id_positive))", :style="{border:(source.resp_per_id_positive!==basicSource.resp_per_id_positive?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info
                img(v-if="basicSource.resp_per_id_positive", :src="basicSource.resp_per_id_positive | image",
                    @click="$zoom($options.filters.image(basicSource.resp_per_id_positive))").mch-image
                template(v-else) 未提交
            .confirm-row    
              .col-name 身份证(国徽面)
              .col-new-info
                img(v-if="source.resp_per_id_opposite", :src="source.resp_per_id_opposite | image",
                    @click="$zoom($options.filters.image(source.resp_per_id_opposite))", :style="{border:(source.resp_per_id_opposite!==basicSource.resp_per_id_opposite?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info
                img(v-if="basicSource.resp_per_id_opposite", :src="basicSource.resp_per_id_opposite | image",
                    @click="$zoom($options.filters.image(basicSource.resp_per_id_opposite))").mch-image
                template(v-else) 未提交
      .align-center
        el-button(type="primary", @click="prevStep", v-if='step > 0') 上一步
        el-button(type="primary", @click="nextStep", v-if="step<2") 下一步
        el-button(type="primary", @click="nextStep", v-else) 确认修改
        el-button(@click="toMain()") 放弃修改

    verifier(ref="modifyMch", @success_verify="toSaveEdit", @abort="abortEdit", scene="MODIFY_INFO", opt="MCH_VERIFY")
</template>

<script>
import { errorDictionaries } from "@/gadgets/dictionaries";
export default {
  data() {
    return {
      step: 0,
      source: {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null,
        change_apply_pic: null,
        opt: 1,
        origin_mch: {},
      },
      basicSource: {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null,
        change_apply_pic: null,
        opt: 1,
        origin_mch: {},
      },
      change_apply_pic: [],
      mch_public_draft_list: [],
      base_mch_public_draft_list: [],
      confirm_mch_public_draft_list: [],
      uploadURL: "/mch_web/v1/upload_picture",
      loading: false,
      bankClassList: [],
      bankAreaList: [],
      bankList: [],
      editPublicObj: {
        bankArea: {},
        bankClass: {},
        bank: {},
        public_account: "",
      },
      step1Change: false,
      step2Change: false,
    };
  },
  watch: {
    "source.mch_name"(newVal, oldVal) {
      this.synchronizationPublic(newVal);
    },
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },
  filters: {
    type(source) {
      switch (source) {
        case 1:
          return "公司";
        case 2:
          return "个人";
        default:
          return source;
      }
    },
    status(source) {
      if (!source && source !== 0) {
        return "-";
      }
      switch (parseInt(source)) {
        case 1:
          return "填写中";
        case 2:
          return "审批中";
        case 3:
          return "审批通过";
        case 4:
          return "审批失败";
        case 5:
          return "用户撤回修改";
        case 6:
          return "审批中";
        default:
          return source;
      }
    },
    settle_type(source) {
      switch (source) {
        case 1:
          return "银行账号";
        case 2:
          return "钱包账号";
        default:
          return source;
      }
    },
    resp_per_id_type(source) {
      switch (source) {
        case "01":
          return "身份证";
        default:
          return source;
      }
    },
  },
  methods: {
    prevStep() {
      if (this.step === 1) {
        this.step--;
        this.step1Change = false;
      }
      if (this.step === 2 && this.source.type == 1) {
        this.step--;
        this.step2Change = false;
      }
      if (this.step === 2 && this.source.type == 2) {
        this.step -= 2;
        this.step1Change = false;
      }
    },
    nextStep() {
      // 判断当前页面
      if (this.step === 2) {
        //提交
        if (!this.step1Change && !this.step2Change && this.source.type !== 2) {
          this.$message.error("当前无任何资料变更");
        } else {
          this.saveEdit();
        }
      }
      if (this.step === 1) {
        this.confirmWallet();
        this.step++;
      }
      if (this.step === 0 && this.source.type == 1) {
        if (this.validateStep()) {
          this.confirmBase();
          this.step++;
        }
      }
      if (this.step === 0 && this.source.type == 2) {
        if (this.validateStep()) {
          this.confirmBase();
          this.step += 2;
        }
      }
    },
    // 匹对钱包信息校验
    confirmWallet() {
      this.confirm_mch_public_draft_list = this.mch_public_draft_list.map((item, idx) => {
        const obj = { ...item };
        if (this.base_mch_public_draft_list[idx]) {
          Object.assign(obj, { source: this.base_mch_public_draft_list[idx] });
        }
        return obj;
      });
      for (let i = 0; i < this.confirm_mch_public_draft_list.length; i++) {
        let item = this.confirm_mch_public_draft_list[i];
        if (item.public_account_name !== item.source.public_account_name) {
          this.step2Change = true;
          break;
        }
        if (item.deposit_bank !== item.source.deposit_bank) {
          this.step2Change = true;
          break;
        }
        if (item.deposit_bank_city !== item.source.deposit_bank_city) {
          this.step2Change = true;
          break;
        }
        if (item.sub_branch_bank !== item.source.sub_branch_bank) {
          this.step2Change = true;
          break;
        }
        if (item.public_account !== item.source.public_account) {
          this.step2Change = true;
          break;
        }
        if (item.public_account_pic !== item.source.public_account_pic) {
          this.step2Change = true;
          break;
        }
      }
    },
    // 匹对基础信息校验
    confirmBase() {
      const type = this.source.type;
      if (type === 1) {
        if (this.source.mch_name !== this.basicSource.mch_name) {
          this.step1Change = true;
          return;
        }
        if (this.source.opt !== this.basicSource.opt) {
          this.step1Change = true;
          return;
        }
        if (this.source.uni_credit !== this.basicSource.uni_credit) {
          this.step1Change = true;
          return;
        }
        if (this.source.business_license !== this.basicSource.business_license) {
          this.step1Change = true;
          return;
        }
        if (this.source.organization_code !== this.basicSource.organization_code) {
          this.step1Change = true;
          return;
        }
        if (this.source.tex_registration_no !== this.basicSource.tex_registration_no) {
          this.step1Change = true;
          return;
        }
        if (this.source.business_license_pic !== this.basicSource.business_license_pic) {
          this.step1Change = true;
          return;
        }
        if (this.source.legal_per_name !== this.basicSource.legal_per_name) {
          this.step1Change = true;
          return;
        }
        if (
          this.source.legal_per_telephone_no !== this.basicSource.legal_per_telephone_no
        ) {
          this.step1Change = true;
          return;
        }
        if (this.source.legal_per_id_type !== this.basicSource.legal_per_id_type) {
          this.step1Change = true;
          return;
        }
        if (this.source.legal_per_id_no !== this.basicSource.legal_per_id_no) {
          this.step1Change = true;
          return;
        }
        if (
          this.source.legal_per_id_positive !== this.basicSource.legal_per_id_positive
        ) {
          this.step1Change = true;
          return;
        }
        if (
          this.source.legal_per_id_opposite !== this.basicSource.legal_per_id_opposite
        ) {
          this.step1Change = true;
          return;
        }
        if (this.source.resp_per_name !== this.basicSource.resp_per_name) {
          this.step1Change = true;
          return;
        }
        if (this.source.resp_per_id_type !== this.basicSource.resp_per_id_type) {
          this.step1Change = true;
          return;
        }
        if (this.source.resp_per_id_no !== this.basicSource.resp_per_id_no) {
          this.step1Change = true;
          return;
        }
      } else {
        if (this.source.resp_per_name !== this.basicSource.resp_per_name) {
          this.step1Change = true;
          return;
        }
        if (this.source.resp_per_id_no !== this.basicSource.resp_per_id_no) {
          this.step1Change = true;
          return;
        }
      }
    },
    synchronizationPublic(publicName) {
      if (this.mch_public_draft_list.length && this.mch_public_draft_list.length > 0) {
        this.mch_public_draft_list.forEach((item) => {
          item.public_account_name = publicName;
        });
      }
    },
    async editPublic(idx) {
      const editing = this.mch_public_draft_list.find((item) => item.isEdit);
      console.log(editing);
      if (editing) {
        this.$message.error("存在提现账号修改，请先保存后再编辑");
        return;
      }
      let newValue = this.mch_public_draft_list[idx];
      newValue.isEdit = true;
      this.$set(this.mch_public_draft_list, idx, newValue);
      this.editPublicObj = Object.assign(this.editPublicObj, newValue);
      await this.handleData();
    },
    // 获取回选的开户行 地 支行的信息
    async handleData() {
      this.editPublicObj.bankClass = {
        class_code: this.editPublicObj.deposit_bank_id,
        class_name: this.editPublicObj.deposit_bank,
      };
      await this.getBankAreaList();
      this.editPublicObj.bankArea = {
        area_code: this.editPublicObj.area_id,
        city_name: this.editPublicObj.deposit_bank_city,
        province_name: this.editPublicObj.deposit_bank_province,
      };
      await this.getBankList();
      this.editPublicObj.bank = {
        bank_code: this.editPublicObj.union_bank,
        bank_name: this.editPublicObj.sub_branch_bank,
      };
      await this.getBank();
    },
    confirmPublic(idx) {
      if (!this.editPublicObj.bankClass.class_code) {
        this.$message({
          type: "warning",
          message: `请选择开户银行`,
        });
        return;
      } else if (!this.editPublicObj.bankArea.area_code) {
        this.$message({
          type: "warning",
          message: `请选择开户银行所在地`,
        });
        return;
      } else if (!this.editPublicObj.bank.bank_code) {
        this.$message({
          type: "warning",
          message: `请选择支行名称`,
        });
        return;
      } else if (!this.editPublicObj.public_account) {
        this.$message({
          type: "warning",
          message: `请输入对公账户账号`,
        });
        return;
      } else if (!this.editPublicObj.public_account_pic) {
        this.$message({
          type: "warning",
          message: `请上传对公账户证明`,
        });
        return;
      }
      let newValue = this.mch_public_draft_list[idx];
      Object.assign(newValue, {
        area_id: this.editPublicObj.area_id,
        deposit_bank: this.editPublicObj.deposit_bank,
        deposit_bank_city: this.editPublicObj.deposit_bank_city,
        deposit_bank_id: this.editPublicObj.deposit_bank_id,
        deposit_bank_province: this.editPublicObj.deposit_bank_province,
        public_account: this.editPublicObj.public_account,
        public_account_name: this.editPublicObj.public_account_name,
        public_account_pic: this.editPublicObj.public_account_pic,
        // bank_code:this.editPublicObj.bank_code,
        sub_branch_bank: this.editPublicObj.sub_branch_bank,
        union_bank: this.editPublicObj.union_bank,
        isEdit: false,
        submitMsg: "保存后提交审核",
      });
      this.$set(this.mch_public_draft_list, idx, newValue);
    },
    cancelPublic(idx) {
      let newValue = this.mch_public_draft_list[idx];
      newValue.isEdit = false;
      this.$set(this.mch_public_draft_list, idx, newValue);
    },
    delImg(idx) {
      this.change_apply_pic.splice(idx, 1);
    },
    getUserInfo() {
      return this.$store.dispatch("GET_USER_INFO");
    },
    getMchDetail() {
      this.loading = true;
      // const { uname } = this.userInfo;
      return this.$store
        .dispatch("LAST_SUCCEED_MCH_DETAIL")
        .then(async (data) => {
          this.source = Object.assign(this.source, data);
          this.basicSource = Object.assign(this.basicSource, data);
          // 判断三证
          this.source.opt = data.uni_credit ? 1 : 2;
          this.basicSource.opt = data.uni_credit ? 1 : 2;
          // 不要怀疑这个，接口历史原因旧的不改！！！！！
          this.source.tax_registration_no = data.tex_registration_no;
          this.basicSource.tax_registration_no = data.tex_registration_no;
          if (data.change_apply_pic) {
            this.change_apply_pic = data.change_apply_pic.split(",");
          }

          // 只有企业类型的时候，才需要对公相关的银行信息
          if (this.source.type == 1) {
            if (!data.mch_public_draft_list || data.mch_public_draft_list.length === 0) {
              this.mch_public_draft_list.push({
                public_account_name: data.mch_name,
                isEdit: false,
              });
            } else {
              this.mch_public_draft_list = data.mch_public_draft_list.map((item) => {
                item.public_account_name = data.mch_name;
                item.isEdit = false;
                return item;
              });
            }

            this.base_mch_public_draft_list = JSON.parse(
              JSON.stringify(this.mch_public_draft_list)
            );
          }
          return data;
        })
        .catch(({ code, msg }) => {
          this.$alert(`商家资料获取失败。${code}：${msg}`, {
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    uploadChange(file, previewKey, urlKey) {
      const { name, size } = file;
      if (size < 0.5 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          this.$set(this.source, previewKey, result);

          const pic_data = result.split(",")[1];
          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.$set(this.source, urlKey, url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过500KB。", {
          type: "error",
        });
      }
    },

    uploadPublicChange(file, previewKey, urlKey) {
      const { name, size } = file;
      if (size < 2 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          this.$set(this.editPublicObj, previewKey, result);

          const pic_data = result.split(",")[1];
          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.$set(this.editPublicObj, urlKey, url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过2MB。", {
          type: "error",
        });
      }
    },

    uploadListChange(file) {
      const { name, size } = file;
      if (this.change_apply_pic.length >= 9) {
        this.$alert(`图片最多上传9张，请先删除部分图片`, {
          type: "error",
        });
        return;
      }
      if (size < 2 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          // this.$set(this[previewKey], result);

          const pic_data = result.split(",")[1];

          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.change_apply_pic.push(url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过2MB。", {
          type: "error",
        });
      }
    },

    toMain() {
      this.$router.push("/merchants-information");
    },
    saveEdit() {
      if (this.validate()) {
        this.$refs.modifyMch.init();
      }
    },
    validateStep() {
      const type = this.source.type;
      if (type === 1) {
        if (!this.source.mch_name) {
          this.$message({
            type: "warning",
            message: `请输入公司名称`,
          });
          return false;
        } else if (!this.source.uni_credit && this.source.opt == 1) {
          this.$message({
            type: "warning",
            message: `请输入统一社会信用代码或注册号`,
          });
          return false;
        } else if (!this.source.business_license && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入营业执照号`,
          });
          return false;
        } else if (!this.source.organization_code && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入组织机构代码`,
          });
          return false;
        } else if (!this.source.tax_registration_no && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入税务登记证件号`,
          });
          return false;
        } else if (!this.source.business_license_pic) {
          this.$message({
            type: "warning",
            message: `请上传营业执照`,
          });
          return false;
        } else if (!this.source.legal_per_name) {
          this.$message({
            type: "warning",
            message: `请输入法人姓名`,
          });
          return false;
        } else if (!this.source.legal_per_telephone_no) {
          this.$message({
            type: "warning",
            message: `请输入法人手机号`,
          });
          return false;
        } else if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: `请输入责任人姓名`,
          });
          return false;
        } else if (!this.source.resp_per_id_no) {
          this.$message({
            type: "warning",
            message: `请输入责任人证件号码`,
          });
          return false;
        } else if (!this.source.legal_per_id_no) {
          this.$message({
            type: "warning",
            message: `请输入法人证件号码`,
          });
          return false;
        } else if (!this.source.legal_per_id_positive) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证正面`,
          });
          return false;
        } else if (!this.source.legal_per_id_opposite) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证反面`,
          });
          return false;
        }
      } else if (type === 2) {
        if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: "请输入个人姓名",
          });
          return false;
        }
      }
      return true;
    },
    validate() {
      const type = this.source.type;
      if (type === 1) {
        if (!this.source.mch_name) {
          this.$message({
            type: "warning",
            message: `请输入公司名称`,
          });
          return false;
        } else if (!this.source.uni_credit && this.source.opt == 1) {
          this.$message({
            type: "warning",
            message: `请输入统一社会信用代码或注册号`,
          });
          return false;
        } else if (!this.source.business_license && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入营业执照号`,
          });
          return false;
        } else if (!this.source.organization_code && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入组织机构代码`,
          });
          return false;
        } else if (!this.source.tax_registration_no && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入税务登记证件号`,
          });
          return false;
        } else if (!this.source.business_license_pic) {
          this.$message({
            type: "warning",
            message: `请上传营业执照`,
          });
          return false;
        } else if (!this.source.legal_per_name) {
          this.$message({
            type: "warning",
            message: `请输入法人姓名`,
          });
          return false;
        } else if (!this.source.legal_per_telephone_no) {
          this.$message({
            type: "warning",
            message: `请输入法人手机号`,
          });
          return false;
        } else if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: `请输入责任人姓名`,
          });
          return false;
        } else if (!this.source.legal_per_id_no) {
          this.$message({
            type: "warning",
            message: `请输入法人证件号码`,
          });
          return false;
        } else if (this.mch_public_draft_list.length === 1) {
          if (!this.mch_public_draft_list[0].deposit_bank) {
            this.$message({
              type: "warning",
              message: `请选择开户银行`,
            });
            return false;
          } else if (!this.mch_public_draft_list[0].public_account) {
            this.$message({
              type: "warning",
              message: `请选择开户银行所在地`,
            });
            return false;
          } else if (!this.mch_public_draft_list[0].sub_branch_bank) {
            this.$message({
              type: "warning",
              message: `请选择支行名称`,
            });
            return false;
          } else if (!this.mch_public_draft_list[0].public_account) {
            this.$message({
              type: "warning",
              message: `请输入对公账户账号`,
            });
            return false;
          } else if (!this.mch_public_draft_list[0].public_account_pic) {
            this.$message({
              type: "warning",
              message: `请上传对公账户证明`,
            });
            return false;
          }
        } else if (!this.source.legal_per_id_positive) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证正面`,
          });
          return false;
        } else if (!this.source.legal_per_id_opposite) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证反面`,
          });
          return false;
        }
      } else if (type === 2) {
        if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: "请输入个人姓名",
          });
          return false;
        }
      }

      if (!this.source.resp_per_id_no) {
        const message = type === 1 ? "请输入责任人证件号" : "请输入证件号码";
        this.$message({
          type: "warning",
          message,
        });
        return false;
      }

      if (
        this.source.origin_mch.enable_wallet_settle === 1 &&
        this.source.origin_mch.status === 2 &&
        this.change_apply_pic.length < 1 &&
        this.source.type === 1
      ) {
        if (
          this.basicSource.legal_per_name != this.source.legal_per_name ||
          this.basicSource.mch_name != this.source.mch_name ||
          this.basicSource.business_license != this.source.business_license ||
          this.basicSource.organization_code != this.source.organization_code ||
          this.basicSource.tax_registration_no != this.source.tax_registration_no ||
          this.basicSource.uni_credit != this.source.uni_credit ||
          this.basicSource.legal_per_id_no != this.source.legal_per_id_no ||
          this.basicSource.legal_per_telephone_no != this.source.legal_per_telephone_no ||
          this.basicSource.public_account != this.source.public_account ||
          //   this.basicSource.public_account != this.source.public_account
          this.basicSource.bank.bank_name != this.source.bank.bank_name
        ) {
          this.$message({
            type: "warning",
            message: `请上传资料修改申请函`,
          });
          return false;
        }

        for (let i = 0; i < this.confirm_mch_public_draft_list.length; i++) {
          if (
            this.confirm_mch_public_draft_list[i].deposit_bank !=
              this.confirm_mch_public_draft_list[i].source.deposit_bank ||
            this.confirm_mch_public_draft_list[i].public_account !=
              this.confirm_mch_public_draft_list[i].source.public_account ||
            this.confirm_mch_public_draft_list[i].sub_branch_bank !=
              this.confirm_mch_public_draft_list[i].source.sub_branch_bank ||
            this.confirm_mch_public_draft_list[i].public_account !=
              this.confirm_mch_public_draft_list[i].source.public_account ||
            this.confirm_mch_public_draft_list[i].public_account_pic !=
              this.confirm_mch_public_draft_list[i].source.public_account_pic
          ) {
            this.$message({
              type: "warning",
              message: `请上传资料修改申请函`,
            });
            return false;
          }
        }
      }
      return true;
    },

    toSaveEdit(biz_ticket) {
      this.loading = true;
      const source = Object.assign({}, this.source, {
        biz_ticket,
        change_apply_pic: this.change_apply_pic.toString(),
      });
      source.mch_public_list = JSON.stringify(this.confirm_mch_public_draft_list);
      delete source.mch_public_draft_list;
      delete source.origin_mch;
      if (source.opt !== 1) {
        delete source.uni_credit;
      }
      if (source.opt !== 2) {
        delete source.business_license;
        delete source.organization_code;
        delete source.tax_registration_no;
      }
      const action =
        this.source.type === 1 ? "EDIT_COMPANY_DETAIL" : "EDIT_PERSON_DETAIL";
      this.$store
        .dispatch(action, source)
        .then(() => {
          this.$alert("您的商家资料已提交审核", {
            type: "success",
          }).then(() => {
            this.toMain();
          });
        })
        .catch(({ code, msg }) => {
          if (code === 1004) {
            const start = msg.indexOf("：");
            const key = msg.substring(start + 1);
            const errorMsg = errorDictionaries[key];
            this.$message({
              type: "error",
              message: `${errorMsg}输入有误，请检查后，重新输入`,
            });
          } else {
            this.$message({
              type: "error",
              message: `${msg}`,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    abortEdit() {
      this.$confirm("是否确认放弃未保存的商家信息？", "提示")
        .then(() => {
          this.toMain();
        })
        .catch(() => {});
    },

    // 获取开户银行
    getBankClassList() {
      this.$store
        .dispatch("GET_BANK_CLASS_LIST")
        .then((data) => {
          this.bankClassList = data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行列表失败。${code}：${msg}`,
          });
        });
    },

    // 获取开户银行区域
    getBankAreaList() {
      return new Promise((resolve, reject) => {
        if (this.editPublicObj.bankClass.class_code) {
          this.editPublicObj.deposit_bank = this.editPublicObj.bankClass.class_name;
          this.editPublicObj.deposit_bank_id = this.editPublicObj.bankClass.class_code;
          this.$store
            .dispatch("GET_BANK_AREA_LIST", this.editPublicObj.bankClass.class_code)
            .then((data) => {
              this.bankAreaList = data;
              this.editPublicObj.bankArea = {};
              this.editPublicObj.bank = {};
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取银行地区列表失败。${code}：${msg}`,
              });
              resolve();
            });
        } else {
          this.editPublicObj.bankArea = {};
          this.editPublicObj.bank = {};
          this.editPublicObj.area_id = null;
          this.editPublicObj.deposit_bank_id = null;
          this.editPublicObj.deposit_bank = null;
          this.editPublicObj.deposit_bank_city = null;
          this.editPublicObj.sub_branch_bank = null;
          this.editPublicObj.union_bank = null;
          resolve();
        }
      });
    },

    // 获取支行
    getBankList() {
      return new Promise((resolve, reject) => {
        if (this.editPublicObj.bankClass.class_code && this.editPublicObj.bankArea) {
          this.editPublicObj.bankArea = this.editPublicObj.bankArea;
          this.editPublicObj.deposit_bank_province = this.editPublicObj.bankArea.province_name;
          this.editPublicObj.deposit_bank_city = this.editPublicObj.bankArea.city_name;
          this.editPublicObj.area_id = this.editPublicObj.bankArea.area_code;
          const params = {
            class_code: this.editPublicObj.bankClass.class_code,
            area_code: this.editPublicObj.bankArea.area_code,
          };
          this.$store
            .dispatch("GET_BANK_LIST", params)
            .then((data) => {
              this.bankList = data;
              this.editPublicObj.bank = {};
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取支行列表失败。${code}：${msg}`,
              });
              resolve();
            });
        } else {
          this.editPublicObj.bank = {};
          this.editPublicObj.deposit_bank = null;
          this.editPublicObj.deposit_bank_city = null;
          this.editPublicObj.sub_branch_bank = null;
          this.editPublicObj.union_bank = null;
          resolve();
        }
      });
    },

    // 获取最后的支行
    getBank() {
      if (this.editPublicObj.bank) {
        this.editPublicObj.sub_branch_bank = this.editPublicObj.bank.bank_name;
        this.editPublicObj.union_bank = this.editPublicObj.bank.bank_code;
      } else {
        this.editPublicObj.sub_branch_bank = null;
        this.editPublicObj.union_bank = null;
      }
    },
  },
  mounted() {
    this.getMchDetail();
    this.getBankClassList();
  },
};
</script>

<style lang="less" scoped>
.img-block {
  position: relative;
  float: left;
}
.del-img {
  // border: 1px solid red;
  background: red;
  color: #fff;
  position: absolute;
  top: 0;
  right: 20px;
  padding: 0 10px;
  text-align: center;
}
.editPublic {
  text-align: center;
  margin-bottom: 10px;
}
.tipTxt {
  color: red;
  text-align: center;
  margin-bottom: 10px;
}
.display-flex {
  flex-direction: column;
}
.wallet-info {
  border: 1px solid black;
  overflow: hidden;
  padding: 40px 20px 20px;
  margin: 20px;
}
.confirm-content {
  // border: 1px solid black;
  overflow: hidden;
  max-width: 1200px;
  .txt-diff {
    color: red;
  }
}
.confirm-wallet {
  overflow: hidden;
  padding: 20px;
  border: 1px solid #333;
  margin: 20px;
}
.confirm-row {
  display: flex;
  min-width: 1000px;

  .col-name {
    width: 30%;
    padding-right: 70px;
    text-align: right;
    margin-bottom: 10px;
  }
  .col-new-info {
    width: 35%;
    margin-bottom: 10px;
  }
  .col-old-info {
    width: 35%;
    margin-bottom: 10px;
  }
}
.mch-image {
  max-width: 90%;
}
.el-form-item {
  .mch-image {
    max-width: 100%;
  }
}
</style>
